// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"17125e97","453":"099f3920"}[chunkId] + ".chunk.js";
};